/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Description_Job_TypeInputs */



/**
* | output |
* | --- |
* | "Shot Description" |
*
* @param {Scene_Description_Job_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_description_job_type = /** @type {((inputs?: Scene_Description_Job_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Description_Job_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description du plan")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schussbeschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione dell'inquadratura")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Описание кадра")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripción de la toma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("镜头描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("撮影内容の説明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट का विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição da cena")
	return /** @type {LocalizedString} */ ("Shot Description")
});